import config from 'react-global-configuration'
config.set({
    ga_tag: "",
    ga_debug: false,
    // base: "http://sandbox.livexgames.com/api",
    // base:"http://uao.livexgames.com/apn/",
    base:"https://xgamesv1.bngrenew.com/api",
    // base:"https://xgames.bngrenew.com/api",
    domain : "btc",
    he : "/he",
    subscribe: '/subscribe',
    requestOTP: "/requestOTP",
    activate: "/activate",
    checkSub: "/checkSub",
    unsubscribe : '/unsubscribe',
    userPacks : '/userPacks',
    appConfig : '/Config' , 
    // appConfig:'/appConfig',
    headers: {
        // "Buildtype":"demo",
        'Reqfrom': 'web',
        'Username': 'web',
        'Language': 'en',
        'Servicefor':'demo'
    }
})


export default config